<!-- =========================================================================================
  File Name: profile.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User not found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
      </span>
    </vs-alert>
    <div id="user-data" v-if="student">
      <vx-card>
      <span v-if="lng!='dogs'">
      <h4  v-if="student.middle_name" class="mb-base">{{student.fname+' '+student.middle_name+' '+student.lname}}</h4>
      <h4  v-else class="mb-base">{{student.fname+' '+student.lname}}</h4>
      </span>
      <span v-else>
       <h4  class="mb-base">{{student.fname}}</h4>
      </span>

        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-2" v-if="student.image">
              <img :src="img_cdn+student.image" class="rounded w-full" @click.stop="editStudentData(student)"/>
            </div>
             <div class="img-container mb-2" v-else>
              <p class="rounded w-full bg-primary text-white" @click.stop="editStudentData(student)" :data-letters="student.fname[0].toUpperCase()"></p>
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td v-if="lng!='dogs'" class="font-semibold">First Name</td>
                <td v-else class="font-semibold">Name</td>
                <td>{{ student.fname}}</td>
              </tr>
               <tr  v-if="lng!='dogs'">
                <td class="font-semibold">Middle Name</td>
                <td v-if="student.middle_name">{{ student.middle_name}}</td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-semibold">Status</td>
                <td v-if="student.status">Enabled</td>
                <td v-else>Disabled</td>
              </tr>
              <tr>
                <td class="font-semibold">Program</td>
                <td><vs-chip v-if="student.program.color_code" class="product-order-status text-white" :style="{background: student.program.color_code}" >{{student.program.name}}</vs-chip>
                 <vs-chip v-else class="product-order-status" >{{student.program.name}}</vs-chip>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Schedule</td>
                <td  v-if="student.schedule">
                   <!-- <p class="font-semibold">{{student.schedule.name}}</p> -->
                   <span v-for="scheduledate in student.schedule.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
                <br>
              </span>
              </td>
              <td v-else>No Schedule</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr v-if="lng!='dogs'">
                <td class="font-semibold">Last Name</td>
                <td>{{ student.lname }}</td>
              </tr>
              <tr v-if="lng!='dogs'">
                <td class="font-semibold">Nickname</td>
                <td v-if="student.nick_name">{{ student.nick_name }}</td>
                <td v-else>N/A</td>
              </tr>

                <tr>
                <td class="font-semibold">Location</td>
                 <td>{{ student.location.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Birthday</td>
                <td v-if="student.dob">{{ student.dob | formatDate}} ({{calculateAge(student.dob)}})</td>
                <td v-else>N/A</td>
              </tr>

            </table>
          </div>

        </div>
      </vx-card>
    </div>
  
  </div>
</template>
<script>
import moment from 'moment'
import {
  TEACHER_SINGLE_STUDENT
} from '@/graphql'

export default {
  name: 'Student.vue',
  components: {
  },
  data: () => ({
    student:'',
    user_not_found: false,
    selected: [],
    settings: { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: .60
    },
    // Data Sidebar
    isMounted: false,
    img_cdn: '',
    lng: ''
  }),
  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    },
    formatDates (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    },
    formatTime (value) {
      if (value) {
        return moment(String(value), 'h:mm A').format('h:mm A')
      }
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },
  methods: {
    calculateAge (dateString) {
      const now = new Date()
      const today = new Date(now.getYear(), now.getMonth(), now.getDate())

      const yearNow = now.getYear()
      const monthNow = now.getMonth()
      const dateNow = now.getDate()

      const dob = new Date(dateString)


      const yearDob = dob.getYear()
      const monthDob = dob.getMonth()
      const dateDob = dob.getDate()
      let age = {}
      let ageString = ''
      let yearString = ''
      let monthString = ''
      let dayString = ''


      let yearAge = yearNow - yearDob

      if (monthNow >= monthDob) var monthAge = monthNow - monthDob
      else {
        yearAge--
        var monthAge = 12 + monthNow - monthDob
      }

      if (dateNow >= dateDob) var dateAge = dateNow - dateDob
      else {
        monthAge--
        var dateAge = 31 + dateNow - dateDob

        if (monthAge < 0) {
          monthAge = 11
          yearAge--
        }
      }

      age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
      }

      if (age.years > 1) yearString = ' years'
      else yearString = ' year'
      if (age.months > 1) monthString = ' months'
      else monthString = ' month'
      if (age.days > 1) dayString = ' days'
      else dayString = ' day'


      if ((age.years > 0) && (age.months > 0) && (age.days > 0)) ageString = `${age.years + yearString  }, ${  age.months  }${monthString}`
      else if ((age.years == 0) && (age.months == 0) && (age.days > 0)) ageString = `Only ${  age.days  }${dayString  } old!`
      else if ((age.years > 0) && (age.months == 0) && (age.days == 0)) ageString = `${age.years + yearString  } old. Happy Birthday!!`
      else if ((age.years > 0) && (age.months > 0) && (age.days == 0)) ageString = `${age.years + yearString  } and ${  age.months  }${monthString}` 
      else if ((age.years == 0) && (age.months > 0) && (age.days > 0)) ageString = `${age.months + monthString  } and ${  age.days  }${dayString}`
      else if ((age.years > 0) && (age.months == 0) && (age.days > 0)) ageString = `${age.years + yearString  } and ${  age.days  }${dayString}` 
      else if ((age.years == 0) && (age.months > 0) && (age.days == 0)) ageString = age.months + monthString 
      else ageString = '0 year'

      return ageString
    },
    get () {
      this.$apollo
        .mutate({
          mutation: TEACHER_SINGLE_STUDENT,
          variables: {
            id: this.$route.params.userId
          }
        })
        .then(response => {
          this.student = response.data.teacher_student
        }).catch(error => {
          console.log(error)
        })

    }
  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#demo-basic-card {
  margin-top: 1.5rem!important;
}
[data-letters]:before {
  content:attr(data-letters);
  display:block;
  border-radius: .25rem !important;
  font-size:100px;
  width: 100% !important;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  height:110px;
  line-height:110px;
  text-align:center;
}
 [data-lettersuser]:before {
  content:attr(data-lettersuser);
   }
  .studentuserdot{
  display:inline-block;
  font-size:50px;
  width:80px;
  height:80px;
  line-height:80px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  margin-left: 100px;
  margin-bottom: 30px;
  }
    // display:inline-block;
  // font-size:50px;
  // width:80px;
  // height:80px;
  // line-height:80px;
  // text-align:center;
  // border-radius:50%;
  // vertical-align:middle;
  // margin-right:1em;
  // margin-left: 100px;
  // margin-bottom: 30px;
</style>
